import { useEffect, useState } from 'react'
import QRCode from 'qrcode'

/** QR code as inline SVG on a white tile (scanners need contrast). */
export function QrCode({
  text,
  label,
  className = '',
}: {
  text: string
  label: string
  className?: string
}) {
  const [svg, setSvg] = useState('')
  useEffect(() => {
    let alive = true
    QRCode.toString(text, {
      type: 'svg',
      errorCorrectionLevel: 'M',
      margin: 1,
      color: { dark: '#000000', light: '#ffffff' },
    }).then((s) => alive && setSvg(s))
    return () => {
      alive = false
    }
  }, [text])
  return (
    <div
      role="img"
      aria-label={label}
      className={`aspect-square rounded-[20px] bg-[#fff] p-3 [&>svg]:size-full ${className}`}
      // Generated by the qrcode library from our own URL – no user HTML involved.
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  )
}
